import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Notes",
  "use": "Notes-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"Notes\">\n  <path d=\"M3 18H15V16H3V18ZM3 6V8H21V6H3ZM3 13H21V11H3V13Z\" fill=\"#323232\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol